import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// RxJs
import { BehaviorSubject, Observable } from 'rxjs';
import { Direction } from '@angular/cdk/bidi';


export interface ILayoutConf {
  navigationPos?: string;   // side, top
  sidebarStyle?: string;    // full, compact, closed
  dir?: Direction | 'auto';             // ltr, rtl
  layoutInTransition?: boolean;
  isMobile?: boolean,
  useBreadcrumb?: boolean,
  breadcrumb?: string,      // simple, title
  topbarFixed?: boolean
}
interface ILayoutChangeOptions {
  duration?: number,
  transitionClass?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  public layoutConf: ILayoutConf;
  layoutConfSubject: BehaviorSubject<ILayoutConf>;
  layoutConf$:Observable<ILayoutConf>;
  public isFullHeight: boolean = false;

  constructor(
    private router: Router
  ) {
    this.layoutConfSubject = new BehaviorSubject<ILayoutConf>(this.layoutConf);
    this.layoutConf$ = this.layoutConfSubject.asObservable();
    this.setAppLayout();
  }

  setAppLayout() {
    this.layoutConf = {
      "navigationPos": "side",
      "sidebarStyle": "compact",
      "dir": "ltr",
      "useBreadcrumb": true,
      "topbarFixed": false,
      "breadcrumb": "title"
    }
  }

  publishLayoutChange(lc: ILayoutConf, opt: ILayoutChangeOptions = {}) {
    let duration = opt.duration || 250;
    if (!opt.transitionClass) {
      this.layoutConf = Object.assign(this.layoutConf, lc);
      return this.layoutConfSubject.next(this.layoutConf);
    }

    this.layoutConf = Object.assign(this.layoutConf, lc, { layoutInTransition: true });
    this.layoutConfSubject.next(this.layoutConf);

    setTimeout(() => {
      this.layoutConf = Object.assign(this.layoutConf, { layoutInTransition: false });
      this.layoutConfSubject.next(this.layoutConf);
    }, duration);
  }
}
